<template>
    <div class="animated fade-in">
        <c-data-table
            class="my-4"
            :items="items"
            :fields="fields"
            :table-filter="true"
            :items-per-page="params.limit"
            items-per-page-select
            hover
            sorter
            :pagination="false"
            :sorterValue="params.sort"
            :tableFilterValue="params.filter"
            :loading="loading"
            @pagination-change="pageChange"
            @update:sorter-value="sortChange"
            @update:table-filter-value="filterChange"
            @row-clicked="viewNewsletter"
        >
<!--            <template #email="{item}">-->
<!--                <td>-->
<!--                    <span v-if="item.user && item.user.email">{{ item.user.email }}</span>-->
<!--                </td>-->
<!--            </template>-->
<!--            <template #type="{item}">-->
<!--                <td>-->
<!--                    <span v-if="item.type">{{ item.type.split('\\').pop() }}</span>-->
<!--                </td>-->
<!--            </template>-->
<!--            <template #name="{item}">-->
<!--                <td>-->
<!--                    <span v-if="item.data && item.data.name">{{ item.data.name }}</span>-->
<!--                </td>-->
<!--            </template>-->
            <template #send_time="{item}">
                <td>
                    <span v-if="item.send_time">{{ item.send_time | moment("MMM D, YYYY, h:mm a") }}</span>
                </td>
            </template>
<!--            <template #actions="{item}">-->
<!--                <td>-->
<!--                    <b-button-group>-->
<!--                        <b-button size="sm" variant="outline-dark" squared v-b-tooltip.hover title="View"-->
<!--                                  @click="viewNewsletter(item)">-->
<!--                            <font-awesome-icon :icon="['fal','eye']"></font-awesome-icon>-->
<!--                        </b-button>-->
<!--                        <b-button size="sm" variant="outline-dark" squared v-b-tooltip.hover title="Re-Send"-->
<!--                                  @click="resendNewsletter(item)">-->
<!--                            <font-awesome-icon :icon="['fal','envelope']"></font-awesome-icon>-->
<!--                        </b-button>-->
<!--                    </b-button-group>-->
<!--                </td>-->
<!--            </template>-->
        </c-data-table>
        <c-pagination
                :active-page="params.page"
                :pages="+(total/params.limit)"
                @update:activePage="updatePageNum"
        ></c-pagination>
        <c-modal scrollable :show.sync="show_preview" title="View Newsletter" size="xl">
            <b-overlay :show="loading_preview">
                <iframe frameborder="0" :src="preview_src" width="100%" height="600"></iframe>
            </b-overlay>
            <template #footer=""><span></span></template>
        </c-modal>
    </div>
</template>

<script>
  import Newsletter from "../../models/Newsletter";

  export default {
    name: 'NewsletterTable',
    data() {
      return {
        loading: true,
        newsletters: null,
        items: [],
        fields: [
          {key: 'subject_line', label: 'Name'},
          // {key: 'title', label: 'Title'},
          {key: 'from_name', label: 'From'},
          {key: 'send_time', label: 'Sent On'},
        ],
        total: null,
        params: {
          page: 1,
          limit: 20,
          sort: {column: 'send_time', asc: false},
          filter: null
        },
        loading_preview: true,
        show_preview: false,
        preview_src: null
      }
    },
    methods: {
      pageChange: function (val) {
        this.params.limit = val;
        this.fetchNewsletters();
      },
      sortChange: function (val) {
        this.params.sort.column = val.column;
        this.params.sort.asc = val.asc;
        this.fetchNewsletters();
      },
      filterChange: function (val) {
        this.params.filter = (val ? (val != '' ? val : null) : null);
        this.fetchNewsletters();
      },
      updatePageNum: function (val) {
        this.params.page = val;
        this.fetchNewsletters();
      },
      fetchNewsletters: function () {
        this.loading = true;
        let params = JSON.parse(JSON.stringify(this.params));
        Newsletter.api().fetch(params).then((results) => {
          this.total = results.response.data.data.pagination.total;
          this.newsletters = results.entities.newsletters;
          this.items = this.newsletters;
          this.loading = false;
        });
      },
      viewNewsletter(newsletter) {
        this.loading_preview = true;
        this.show_preview = true;
        Newsletter.api().view(newsletter.id).then((response) => {
          let data = response.response.data;
          this.preview_src = 'data:text/html;base64,' + btoa(unescape(encodeURIComponent(data)));
          let file = new Blob([data], {type: 'text/html'});
          let urlCreator = window.URL || window.webkitURL;
          let url = urlCreator.createObjectURL(file);
          this.preview_src = url;
          this.loading_preview = false;
        });
      },
    },
    created() {
      this.fetchNewsletters();
    }
  }
</script>
